app.service('articleAdvice', function(modal, validate, captchaService, simpleToastr){
	let isInit = false, isOpen = false;
	let $captcha;

	function open(){
		modal.open('article-advice', {
			callbackClose:function(){
				resetForm();
			}
		});
		if(!isOpen){
			isOpen = true;
			simpleToastr.init();
			validate.task('articleAdviceForm',function(form){
				send(form);
			});
		}
		articleAdviceCaptcha();
	}
	function resetForm(){
		validate.resetForm($('#article-advice-form'));
		articleAdviceCaptchaReload();
	}
	function articleAdviceCaptcha(){
		if($captcha.length){
			captchaService.hidePlace($captcha.data('place'));
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	function articleAdviceCaptchaReload(){
		captchaService.reset($captcha.attr('id'));
	}
	function send($form){
		let params = {};
		$form.addClass('loading');
		$form.serializeArray().forEach(element => {
			params[element.name] = element.value;
		});
		$.ajax({
			url: '/articleAdvice.ltr',
			method:'POST',
			data: params,
			success:function(json){
				$form.removeClass('loading');
				if(json.status == 'SUCCESS'){
					modal.close('article-advice');
					simpleToastr.open('article-advice-success');
					resetForm();
				}else{
					json.messages != '' ? articleAdviceCaptcha() : modal.alert('Wystapił błąd wysyłania formularza. Prosimy spróbować później');
				}
			},error:function(){
				$form.removeClass('loading');
				modal.alert('Wystapił błąd wysyłania formularza. Prosimy spróbować później');
			}
		});
	}

	function setElements(){
		$captcha = $('#modal-article-advice').find('[data-toggle="captcha"]');
	}
	function setEvents(){
		if(!isInit){
			isInit = true;
			$('body').on('click','.js-article-advice-form',function(){
				open();
			});
		}
	}
	function init(){
		setElements();
		setEvents();
	}
	return{
		init: init
	};
});
